import {Breadcrumbs, DataTable, FormDialog, name, Title} from '@management-ui/core';
import {Add} from '@mui/icons-material';
import {Box, Button} from '@mui/material';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useCallback, useContext, useMemo, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ServiceContext} from '../../../components/Services';
import TableHolder from '../../../components/TableHolder';
import YesNo from '../../../components/YesNo';
import routes from '../../../routes';
import UserForm from '../forms/UserForm';

const Users = () => {
  const services = useContext(ServiceContext);
  const history = useHistory();
  const [showNew, setShowNew] = useState(false);

  const goToDetail = useCallback((user) => {
    history.push(reverse(routes.users.detail, {id: user.id}));
  }, [history]);

  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Users'}]}/>
      <Title title="Users">
        <Box display="flex" flex={1} justifyContent="flex-end">
          <Button variant="contained" startIcon={<Add/>} onClick={() => setShowNew(true)} color="success">
            Add New User
          </Button>
        </Box>
      </Title>
      <TableHolder>
        <DataTable
          title=""
          columns={useMemo(() => [
            {title: 'Name', field: 'name', render: data => name(data)},
            {title: 'Email', field: 'email'},
            {title: 'Active?', field: 'is_active', render: data => <YesNo value={data.is_active}/>},
          ], [])}
          loadData={query => new Promise((resolve, reject) => {
            services.user.getTableUsers(query)
              .then(response => {
                resolve({
                  data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
                });
              }).catch(() => {
              reject();
            });
          })}
          onRowClick={goToDetail}
        />
      </TableHolder>
      <FormDialog
        title="Add New User"
        open={showNew}
        onClose={() => setShowNew(false)}
        maxWidth="md"
        render={(props) => (
          <UserForm
            {...props}
            user={{}}
            onSaved={goToDetail}/>
        )}
      />
    </div>
  );
};

export default Users;
